
import { Customer } from '@/lib/supabase/customers/types';

// Helper function to format date
export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch (e) {
    return dateString;
  }
};

// Helper function to format phone number
export const formatPhone = (phone?: string): string => {
  if (!phone) return 'N/A';
  
  // Basic formatting, can be enhanced for specific country formats
  return phone;
};

// Map a database customer record to our Customer interface
export const mapDatabaseCustomerToCustomer = (customer: any): Customer => ({
  id: customer.id,
  name: customer.name,
  email: customer.email,
  phone: customer.phone,
  country: customer.country,
  region: customer.region,
  municipality: customer.municipality,
  address: customer.address,
  organization_id: customer.organization_id,
  shop_id: customer.shop_id,
  orders_count: customer.orders_count || 0,
  total_spent: customer.total_spent || 0,
  created_at: customer.created_at,
  updated_at: customer.updated_at || customer.created_at,
});
